import { BASE_API_URL } from '@/constants/api'
import { getImageUrl } from '@/constants/images'

const DOC_TYPE_TO_ICON = {
  sanction_letter: 'letter',
  consolidated_agreement: 'agreement',
  ndc: 'letter'
}

export const getDocIcon = docType => getImageUrl(DOC_TYPE_TO_ICON[docType] ?? 'letter')

export const resolveDocumentUrlFromResponse = response => {
  const url = response?.url
  return typeof url === 'string' ? url : null
}

export const buildDocumentRequestUrl = path => {
  if (!path || typeof path !== 'string') {
    return ''
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${BASE_API_URL}${normalized}`
}
